import styled from '@emotion/styled';
import { flexbox } from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { Div } from './Div';

export const Box = styled(Div, {
    shouldForwardProp,
})(
    {
        boxSizing: 'border-box',
        minWidth: 0,
    },
    flexbox,
);
